<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-xl-12 col-lg-12">
				<div class="card">
					<div class="card-header d-flex justify-content-between">
						<div class="header-title">
							<h4 class="card-title">Add Student</h4>
						</div>
					</div>
					<div class="card-body">
						<div class="new-user-info">
							<b-form @submit.prevent="addStudent">
								<div class="row">
									<div class="form-group col-md-4">
										<label>Name <span class="required">*</span></label>
										<b-form-input v-model="student.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
										<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
											<p class="mb-0">{{ val }}</p>
										</div>
									</div>
									<div class="form-group col-md-4">
										<label>Enrollment Number <span class="required">*</span></label>
										<b-form-input v-model="student.entrolment_no" v-bind:class="{ 'is-invalid': Boolean(errors.entrolment_no) }"></b-form-input>
										<div v-for="(val, index) in errors.entrolment_no" :key="index" class="invalid-feedback">
											<p class="mb-0">{{ val }}</p>
										</div>
									</div>
									<div class="form-group col-md-4">
										<label>Date of Birth <span class="required">*</span></label>
										<b-form-input type="date" v-model="student.dob" value-as-string v-bind:class="{ 'is-invalid': Boolean(errors.dob) }"></b-form-input>
										<div v-for="(val, index) in errors.dob" :key="index" class="invalid-feedback">
											<p class="mb-0">{{ val }}</p>
										</div>
									</div>									
									<div class="form-group col-md-4">
										<label>Phone Number</label>
										<b-form-input v-model="student.phone" v-bind:class="{ 'is-invalid': Boolean(errors.phone) }"></b-form-input>
										<div v-for="(val, index) in errors.phone" :key="index" class="invalid-feedback">
											<p class="mb-0">{{ val }}</p>
										</div>
									</div>
									<div class="form-group col-md-4">
										<label>Email ID</label>
										<b-form-input v-model="student.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
										<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
											<p class="mb-0">{{ val }}</p>
										</div>
									</div>
									<div class="form-group col-md-4">
										<label>Father's Name <span class="required">*</span></label>
										<b-form-input v-model="student.father_name" v-bind:class="{ 'is-invalid': Boolean(errors.father_name) }"></b-form-input>
										<div v-for="(val, index) in errors.father_name" :key="index" class="invalid-feedback">
											<p class="mb-0">{{ val }}</p>
										</div>
									</div>
									<div class="form-group col-md-4">
										<label>Mother's Name <span class="required">*</span></label>
										<b-form-input v-model="student.mother_name" v-bind:class="{ 'is-invalid': Boolean(errors.mother_name) }"></b-form-input>
										<div v-for="(val, index) in errors.mother_name" :key="index" class="invalid-feedback">
											<p class="mb-0">{{ val }}</p>
										</div>
									</div>
									<div class="form-group col-md-4">
										<label>Gender <span class="required">*</span></label>
										<select class="form-control" v-model="student.gender" v-bind:class="{ 'is-invalid': Boolean(errors.gender) }">
											<option value="">Select Gender</option>
											<option value="1">Male</option>
											<option value="2">Female</option>
											<option value="3">Others</option>
										</select>
										<div v-for="(val, index) in errors.gender" :key="index" class="invalid-feedback">
											<p class="mb-0">{{ val }}</p>
										</div>
									</div>
									<div class="form-group col-md-4">
										<label>State <span class="required">*</span></label>
										<b-form-select v-model="student.state" v-bind:class="{ 'is-invalid': Boolean(errors.state) }" @change="fetchDistricts()">
											<template #first>
												<b-form-select-option value="null" disabled>-- Select state --</b-form-select-option>
											</template>
											<b-form-select-option v-for="state in states" :key="state.id" :value="state.id">{{ state.state }}</b-form-select-option>
										</b-form-select>
										<div v-for="(val, index) in errors.state" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									    </div>
									</div>

									<div class="form-group col-md-4">
										<label>District <span class="required">*</span></label>
										<b-form-select v-model="student.district" v-bind:class="{ 'is-invalid': Boolean(errors.district) }">
											<template #first>
											<b-form-select-option value="null" disabled>-- Select district --</b-form-select-option>
											</template>
											<b-form-select-option v-for="district in districts" :key="district.id" :value="district.id">{{ district.district }}</b-form-select-option>
										</b-form-select>
										<div v-for="(val, index) in errors.district" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									    </div>
									</div>

									<div class="form-group col-md-4">
										<label>Department <span class="required">*</span></label>
										<b-form-select v-model="student.department" v-bind:class="{ 'is-invalid': Boolean(errors.department) }">
											<template #first>
											<b-form-select-option value="null" disabled>-- Select department --</b-form-select-option>
											</template>
											<b-form-select-option v-for="department in departments" :key="department.id" :value="department.id">{{ department.department }}</b-form-select-option>
										</b-form-select>
										<div v-for="(val, index) in errors.department" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									    </div>
									</div>

									<div class="form-group col-md-4">
									   <label>Course <span class="required">*</span></label>
										<b-form-select v-model="student.course" v-bind:class="{ 'is-invalid': Boolean(errors.course) }">
											<template #first>
											<b-form-select-option value="null" disabled>-- Select courses --</b-form-select-option>
											</template>
											<b-form-select-option v-for="course in courses" :key="course.id" :value="course.id">{{ course.course }}</b-form-select-option>
										</b-form-select>
										<div v-for="(val, index) in errors.course" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									    </div>
									</div>

									<div class="form-group col-md-4">
									   <label>Branch <span class="required">*</span></label>
										<b-form-select v-model="student.branch" v-bind:class="{ 'is-invalid': Boolean(errors.branch) }" @change="fetchSubBranches()">
											<template #first>
											<b-form-select-option value="null" disabled>-- Select branch --</b-form-select-option>
											</template>
											<b-form-select-option v-for="branch in branches" :key="branch.id" :value="branch.id">{{ branch.branch }}</b-form-select-option>
										</b-form-select>
										<div v-for="(val, index) in errors.branch" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									    </div>
									</div>

									<div class="form-group col-md-4">
										<label>Sub Branch </label>
										<b-form-select v-model="student.sub_branch" v-bind:class="{ 'is-invalid': Boolean(errors.sub_branch) }">
											<template #first>
											<b-form-select-option value="null" disabled>-- Select sub branch --</b-form-select-option>
											</template>
											<b-form-select-option v-for="sub_branch in sub_branches" :key="sub_branch.id" :value="sub_branch.id">{{ sub_branch.subbranch }}</b-form-select-option>
										</b-form-select>
										<div v-for="(val, index) in errors.sub_branch" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									    </div>
									</div>

									<div class="form-group col-md-4">
										<label>Session <span class="required">*</span></label>
										<b-form-select v-model="student.session" v-bind:class="{ 'is-invalid': Boolean(errors.session) }">
											<template #first>
											<b-form-select-option value="null" disabled>-- Select session --</b-form-select-option>
											</template>
											<b-form-select-option v-for="session in sessions" :key="session.id" :value="session.id">{{ session.start }}-{{ session.end }}</b-form-select-option>
										</b-form-select>
										<div v-for="(val, index) in errors.session" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									    </div>
									</div>

									<div class="form-group col-md-4">
									   <label>Centre <span class="required">*</span></label>
									   <b-form-select v-model="student.centre" v-bind:class="{ 'is-invalid': Boolean(errors.centre) }">
											<template #first>
											<b-form-select-option :value="null" disabled>-- Select centre --</b-form-select-option>
											</template>
											<b-form-select-option v-for="centre in centres" :key="centre.id" :value="centre.id">{{ centre.centre }}</b-form-select-option>
										</b-form-select>
										<div v-for="(val, index) in errors.centre" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									    </div>
									</div>
                                    
                                     <div class="form-group col-md-4">
										<label class="control-label">Student Address</label>
										<b-form-textarea rows="3" v-model="student.address" v-bind:class="{ 'is-invalid': Boolean(errors.address) }"></b-form-textarea>
										<div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
											<p class="mb-0">{{ val }}</p>
										</div>
								   </div>
								</div>
								
								<button type="submit" class="btn btn-primary">Submit</button>
							</b-form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "AddStudent",
		data() {
			return {
				student: {
					name: '',
					dob:'',
					entrolment_no: '',
					state: null,
					district: null,
					centre: null,
					department: null,
					course: null,
					branch: null,
					sub_branch: null,
					session: null,
					phone: '',
					email: '',
					gender: '',
					father_name: '',
					mother_name: '',
					address: ''
				},				
				
				keyword: "",
				visible: false,
				status: '',
				token: "",
				errors: {},
				activate: false,

				states: {},
				districts: {},
				departments: {},
				branches: {},
				sub_branches: {},
				courses: {},
				centres: {},
                sessions: {},
                inputs: [
	                       {value: null}
	                    ],
			};
		},
 
		mounted() {
			
		},
   
		created() {			
			this.fetchStates();
			// this.fetchDistricts();
			this.fetchDepartments();
			this.fetchSessions();
			this.fetchCourses();
			this.fetchCentres();
			this.fetchBranches();
			// this.fetchSubBranches();
		},
        
        methods: {

        	GetData()
        	{
               alert(this.student.dob); 
        	},

			add() {
	         this.inputs.push({ value: null });
	      },

	      remove(index) {
	         this.inputs.splice(index, 1);
	      }, 

		  decimalsOnly(event) {
		      let keyCode = event.keyCode;
		      if (keyCode >= 48 || keyCode <= 57 || keyCode == 46 ) {
		      	return;
		      } else {
		        event.preventDefault();
		      }
		    },
		    alphaSpacesOnly(event) {
		    	let keyCode = event.keyCode;
			    if ((keyCode >= 65 && keyCode <= 90) || 
			    	(keyCode >= 97 && keyCode <= 122) ||			    	
			    	(keyCode == 32)) {
			        return;
			    } else {
			    	event.preventDefault();
			    }
		    },
		   
			getToken() {
				if (localStorage.token) {
					this.token = localStorage.token;
				} else {
					this.$vToastify.error("Session expired, please login again");
					this.$router.push({ name: "auth.login" });
				}
			},

			fetchStates() {
				let url = "/api/students/states";			
				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.states = responseData.data;
					})
					.catch((err) => console.log(err));
			},
            
            fetchDistricts() {	
                // alert(this.student.state);			
				let url = "/api/students/districts?state_id=" + this.student.state;	
				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.districts = responseData.data;
					})
					.catch((err) => console.log(err));
			},

			fetchSessions() {
				let url = "/api/students/sessions";				
				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.sessions = responseData.data;
					})
					.catch((err) => console.log(err));
			},
            
            fetchBranches() {
				let url = "/api/students/branches";				
				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.branches = responseData.data;
					})
					.catch((err) => console.log(err));
			},

			fetchSubBranches() {				
				let url = "/api/students/sub_branches?branch_id=" + this.student.branch;	
				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.sub_branches = responseData.data;
					})
					.catch((err) => console.log(err));
			},

			fetchDepartments() {
				let url = "/api/students/departments";
				this.getToken();
				this.$axios
					.get(url, {
						headers: { Authorization: "Bearer " + this.token },
					})
					.then((res) => {
						var responseData = res.data;
						this.departments = responseData.data;
					})
					.catch((err) => console.log(err));
			},

			fetchCourses() {
				let url = "/api/students/courses";
				this.$axios
					.get(url, {
						headers: { Authorization: "Bearer " + this.token },
					})
					.then((res) => {
						var responseData = res.data.data;
						this.courses = responseData;
					})
					.catch((err) => console.log(err));
			},
            
            fetchCentres() {
				let url = "/api/students/centres";
				this.$axios
					.get(url, {
						headers: { Authorization: "Bearer " + this.token },
					})
					.then((res) => {
						var responseData = res.data.data;
						this.centres = responseData;
					})
					.catch((err) => console.log(err));
			},

			addStudent() {
				this.getToken();
				let formData = new FormData();
				formData.append("name", this.student.name);
				formData.append("entrolment_no", this.student.entrolment_no);
				formData.append("state", this.student.state);
				formData.append("district", this.student.district);
				formData.append("centre", this.student.centre);
				formData.append("department", this.student.department);
				formData.append("course", this.student.course);
				formData.append("branch", this.student.branch);
				formData.append("sub_branch", this.student.sub_branch);
				formData.append("session", this.student.session);
				formData.append("phone", this.student.phone);
				formData.append("email", this.student.email);
				formData.append("gender", this.student.gender);
				formData.append("father_name", this.student.father_name);
				formData.append("mother_name", this.student.mother_name);
				formData.append("address", this.student.address);
				formData.append("dob", this.student.dob);

				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};

				let url;
				url = "/api/students/add";

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$vToastify.success(response.data.message);
						} else {
							this.$vToastify.error(response.data.message);
						}
						this.clearForm();
						this.$router.push({ name: "students" });
					})
					.catch((error) => {
						this.errors = {};
						if (error.response) {
							if (error.response.data.message) {
								console.log(error.response.data);
								this.errors = error.response.data.message;
								console.log(this.errors);
							} else {
								this.$vToastify.error("Error!");
							}
						} else {
							this.$vToastify.error("Error!");
						}
					});
			},

			clearForm() {
				this.fetchStates();
				// this.fetchDistricts();
				this.fetchSessions();
				this.fetchCourses();
				this.fetchCentres();
				this.fetchBranches();
				// this.fetchSubBranches();
				this.fetchDepartments();
				this.student.name = '';
				this.student.dob ='';
				this.student.entrolment_no = null;
				this.student.state = null;
				this.student.district = null;
				this.student.centre = null;
				this.student.department = null;
				this.student.course = null;
				this.student.branch = null;
				this.student.sub_branch = null;
				this.student.session = null;
				this.student.phone = null;
				this.student.email = '';
				this.student.gender = null;
				this.student.father_name = '';
				this.student.mother_name = '';
				this.student.address = '';
				this.inputs = [{value: null}];
				this.errors = {};
				this.keyword = '';
			},
		},

	};
</script>
